import {Component, OnDestroy, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {combineLatest, Subscription} from "rxjs";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {SponsorService} from "../../common/sponsor.service";
import {ISponsorDetails} from "../../social/social-models";
import {CustomerUtil} from "../../util/customer-util";
import {IShopUser} from "../../session/customer-models";
import {SponsorChangeModalComponent} from "./sponsor-change-modal/sponsor-change-modal.component";
import {AuthUtil} from "../../auth/auth-util";

@Component({
    selector: 'attribution-bar',
    templateUrl: './attribution-bar.component.html',
    styleUrls: ['./attribution-bar.component.scss'],
    standalone: false
})
export class AttributionBarComponent extends BaseComponent implements OnInit, OnDestroy {

    sponsorDisplayName: string;
    showBar: boolean = false;
    isRetail: boolean = false;

    private subscriptions: Subscription = new Subscription();
    private modalRef: BsModalRef;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private sponsorService: SponsorService,
        private modalService: BsModalService
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.subscriptions.add(
            combineLatest([
                this.sponsorService.attributionSponsor$(),
                this.userService.watchShopUser()
            ]).subscribe(([sponsorDetails, user]: [ISponsorDetails, IShopUser]) => {
                this.sponsorDisplayName = this.resolveDisplayName(sponsorDetails);
                this.showBar = !!sponsorDetails?.sponsorId && !!this.sponsorDisplayName;
                this.isRetail = AuthUtil.isRetail(user);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Names the sponsor the shopper is saving with. A sponsor can arrive with an id and no name — the
     * gateway returns the bare id when the details lookup is rejected — so this falls back to what the
     * shopper actually arrived through: the site they clicked or typed, then the id, which is only ever
     * reached when a number is what they entered themselves. The site resolves off the no-auth portal,
     * so it is usually present on exactly the responses that came back without a name.
     */
    private resolveDisplayName(sponsorDetails: ISponsorDetails): string {
        // prefer the PWP profile name, matching what the sponsor's own site calls them
        return CustomerUtil.getSponsorDisplayName(sponsorDetails, true)
            || sponsorDetails?.site
            || (sponsorDetails?.sponsorId ? String(sponsorDetails.sponsorId) : undefined);
    }

    openSponsorChangeModal(): void {
        this.modalRef = this.modalService.show(SponsorChangeModalComponent, {
            class: 'sponsor-change-dialog'
        });
    }
}
